import { type ThemeOptions } from '@mui/material';

export function createTabStyles() {
  return {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            '&::after': {
              borderRadius: `${theme.ui.focus.borderRadius}`,
              content: '""',
              inset: '0.6em',
              outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
              outlineOffset: `${theme.ui.focus.outlineOffset}`,
              position: 'absolute',
            },
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
